import IMask from "imask";
import { initTokenizedWebComponent } from "./tokenized";

const template = document.createElement("template");
template.innerHTML = `
      <style>

      #text-entry {
          outline: none;
          border: none;
          flex-grow: 1;
          margin:0;
          padding: 0 0 0 0.5rem;
      }
      </style>
      <s6-tokenized>
      <input id="text-entry"></input>
      </s6-tokenized>
    `;
initTokenizedWebComponent();
export class MultivalueElement extends HTMLElement {
    private _shadowRoot: ShadowRoot;
    private input: HTMLInputElement;
    private _valid: boolean;
    private mask: IMask.InputMask<IMask.MaskedRegExp>;
    private tokens: any;

    constructor() {
        super();
        this._shadowRoot = this.attachShadow({ mode: "open" });
        this._shadowRoot.appendChild(template.content.cloneNode(true));
        this.setAttribute("data-s6-focusable", "true");
        this.input = this._shadowRoot.querySelector("input");
        this.input.addEventListener("keyup", this.keyup);
        this.input.addEventListener("focus", () => {
            this.tokens.focus();
        });
        this.input.addEventListener("blur", (evt) => {
            this.tokens.blur();
            this.valid = this._valid;
            this.keyup(evt);
        });
        this.tokens = this._shadowRoot.querySelector("s6-tokenized");
        this.tokens.addEventListener("click", () => {
            this.focus();
        });
        this.tokens.addEventListener("change", (evtº) => {
            this.dispatchEvent(new Event("change"));
        });
        if (this.hasAttribute("isNumeric")) {
            this.tokens.setAttribute("isNumeric", this.getAttribute("isNumeric"));
        }
        if (this.hasAttribute("isNumeric")) {
            this.setAttribute("allowedPattern", "^\\d+$");
        }
        this.mask = this.initMask();
    }

    private connectedCallback() {
        this.upgradeProperty("readOnly");
    }
    private upgradeProperty(prop) {
        if (this.hasOwnProperty(prop)) {
            let value = this[prop];
            delete this[prop];
            this[prop] = value;
        }
    }
    private initMask(): IMask.InputMask<IMask.MaskedRegExp> {
        if (this.getAttribute("allowedPattern") != null && this.getAttribute("allowedPattern") !== "") {
            const maskOptions = {
                mask: new RegExp(this.getAttribute("allowedPattern")),
            } as any;
            return IMask(this.input, maskOptions);
        }
    }

    private keyup = (e) => {
        if (e.key == null || e.key === " " || e.key === ",") {
            let value = e.target.value;
            this.tokenize(value);
        }
    }

    private tokenize(value) {
        let values = value.split(/[\s,]+/);
        let changed = false;
        let data = this.tokens.data ?? [];
        for (const val of values) {
            let v;
            if (val === "" || val === " " || val === ",") {
                continue;
            }
            let token;
            token = document.createElement("s6-text-token");
            token.innerText = v;
            this.input.value = "";
            this.mask?.updateValue();

            if (this.hasAttribute("isNumeric")) {
                data.push(parseInt(val));
            } else {
                data.push(val);
            }
            changed = true;
        }
        if (changed) {
            this.tokens.data = data;
            this.dispatchEvent(new Event("change"));
        }
    }

    public set data(data: any[]) {
        this.tokens.data = data;
    }

    public get data() {
        if (this.tokens.data?.length === 0) {
            return null;
        }
        return this.tokens.data;
    }

    public focus() {
        this.input.focus();
    }

    public set readOnly(ro: boolean) {
        if (ro) {
            this.setAttribute("readonly", "true");
            this.input.remove();
        } else {
            this.removeAttribute("readonly");
            if (!this.input.isConnected) {
                this.tokens.append(this.input);
            }
            this.input.style.display = "inline-block";
        }
        this.tokens.readOnly = ro;
    }

    public set valid(valid: boolean) {
        this._valid = valid ?? true;
        this.tokens.valid = valid;
    }

    public set validationMessage(message) {
        this.tokens.validationMessage = message;
    }
}

export function initMultivalueWebComponent() {
    window.customElements.define("s6-multivalue", MultivalueElement);
}
